import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

export const cddrcp4530 = new FeatureLayer({
    url: "https://njmaps1.rad.rutgers.edu/arcgis/rest/services/Climate/ZZ_CoolingDegreeDays/MapServer/8",
    title: 'Cooling Degree Days Change until 2030',
    opacity: 0.4,
    oraId: 'cddrcp4530',
  })